var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      ref: "headerpart",
      staticClass: "header",
      class: {
        "msg-fixed":
          _vm.betSlipState &&
          _vm.headerMessageState &&
          _vm.mobileBigAndBelow &&
          !_vm.isOpenedFromWebView
      }
    },
    [
      _c("resize-observer", { on: { notify: _vm.headerResize } }),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "top-container",
          class: { geo_search: _vm.mobileGeolocationInProgress.display },
          attrs: { "align-center": "" }
        },
        [
          _vm.mobileBigAndBelow
            ? _c(
                "v-icon",
                {
                  on: {
                    click: function($event) {
                      return _vm.toggleHamburgerMenu()
                    }
                  }
                },
                [_vm._v("menu")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileBigAndBelow
            ? _c(
                "v-navigation-drawer",
                {
                  staticClass: "dialog-menu hamburger",
                  attrs: {
                    app: "",
                    fixed: "",
                    "disable-resize-watcher": "",
                    "disable-route-watcher": ""
                  },
                  model: {
                    value: _vm.dialogHamburgerMenu,
                    callback: function($$v) {
                      _vm.dialogHamburgerMenu = $$v
                    },
                    expression: "dialogHamburgerMenu"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("logo", { attrs: { mode: "hamburgermenu" } }),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleHamburgerMenu()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hamburger-menu")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.mobileBigAndBelow
            ? _c(
                "v-flex",
                { staticClass: "logo" },
                [
                  _c("router-link", { attrs: { to: "/" } }, [
                    _c("img", {
                      attrs: {
                        src:
                          "/static/images/logo/logo-" + _vm.brandKey + ".png",
                        alt: _vm.brandKey
                      }
                    })
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobileBigAndBelow
            ? _c(
                "div",
                {
                  staticClass: "logo",
                  on: {
                    click: function($event) {
                      return _vm.toTop()
                    }
                  }
                },
                [_c("router-link", { attrs: { to: "/" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.mobileBigAndBelow
            ? _c(
                "v-flex",
                {
                  staticClass: "menu",
                  attrs: { sm12: "", "align-content-end": "" }
                },
                [
                  _c("site-navigation", {
                    staticClass: "other-links navigation",
                    attrs: { "navigation-section": "HEADER_MENU_RWC" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenedFromWebView && _vm.mobileGeolocationInProgress.display
        ? _c("mobile-geolocation-dialog")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df067998", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df067998","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/HeaderPart.vue
// module id = null
// module chunks = 